import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { SessionService } from '../../../../session/session.service';
import { Session } from '../../../../../shared/model/session.model';
import moment from "moment";
import * as i0 from "@angular/core";
import * as i1 from "@ng-bootstrap/ng-bootstrap";
import * as i2 from "../../../../session/session.service";
import * as i3 from "@angular/common";
import * as i4 from "@fortawesome/angular-fontawesome";
import * as i5 from "../../../../../ng-jhipster/language/jhi-translate.directive";
const _c0 = function (a0) { return { secondsLeft: a0 }; };
function SessionIsAboutToEndComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelementStart(1, "div", 2);
    i0.ɵɵelementStart(2, "fa-icon", 3);
    i0.ɵɵlistener("click", function SessionIsAboutToEndComponent_div_0_Template_fa_icon_click_2_listener() { i0.ɵɵrestoreView(_r2); const ctx_r1 = i0.ɵɵnextContext(); return ctx_r1.close(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 4);
    i0.ɵɵelement(4, "h4", 5);
    i0.ɵɵelementStart(5, "div", 6);
    i0.ɵɵelementStart(6, "button", 7);
    i0.ɵɵlistener("click", function SessionIsAboutToEndComponent_div_0_Template_button_click_6_listener() { i0.ɵɵrestoreView(_r2); const ctx_r3 = i0.ɵɵnextContext(); return ctx_r3.close(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "button", 8);
    i0.ɵɵlistener("click", function SessionIsAboutToEndComponent_div_0_Template_button_click_7_listener() { i0.ɵɵrestoreView(_r2); const ctx_r4 = i0.ɵɵnextContext(); return ctx_r4.extendSessionByTenMinutes(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("translateValues", i0.ɵɵpureFunction1(1, _c0, ctx_r0.secondsLeft));
} }
export class SessionIsAboutToEndComponent {
    constructor(modalService, sessionService) {
        this.modalService = modalService;
        this.sessionService = sessionService;
    }
    ngOnInit() {
        this.updateSecondsLeftRecurring();
    }
    ngOnDestroy() {
        console.log('DEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEES');
        if (this.updateSecondsLeftRecurringHandle) {
            clearInterval(this.updateSecondsLeftRecurringHandle);
        }
    }
    extendSessionByTenMinutes() {
        this.sessionService.extendSession(this.session.id).subscribe(s => {
            this.close();
        });
    }
    updateSecondsLeftRecurring() {
        this.updateSecondsLeftRecurringHandle = setTimeout(() => {
            console.log("setTimeout 2: " + this.secondsLeft);
            const sessionEnd = moment(this.session.sessionStartTime).add(this.session.duration, 'minutes');
            const now = moment.now();
            const secondsLeft = sessionEnd.diff(now, 'seconds');
            let partialMinute = secondsLeft % 60 > 0 ? 1 : 0;
            const minutesLeft = sessionEnd.diff(now, 'minutes') + partialMinute;
            this.secondsLeft = secondsLeft > 0 ? secondsLeft : 0;
            if (this.secondsLeft > 0) {
                this.updateSecondsLeftRecurring();
            }
            else {
                this.close();
            }
        }, 1000);
    }
    close() {
        this.modalService.dismissAll();
    }
}
SessionIsAboutToEndComponent.ɵfac = function SessionIsAboutToEndComponent_Factory(t) { return new (t || SessionIsAboutToEndComponent)(i0.ɵɵdirectiveInject(i1.NgbModal), i0.ɵɵdirectiveInject(i2.SessionService)); };
SessionIsAboutToEndComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SessionIsAboutToEndComponent, selectors: [["session-is-about-to-end"]], inputs: { session: "session" }, decls: 1, vars: 1, consts: [["class", "olha-theme", 4, "ngIf"], [1, "olha-theme"], [1, "d-flex", "justify-content-end"], ["icon", "times-circle", 1, "mt-3", "mr-3", 2, "cursor", "pointer", 3, "click"], [1, "modal-body", "text-center", "pt-0"], ["jhiTranslate", "sessionChat.Session is about to end", 3, "translateValues"], [1, "d-flex", "justify-content-center", "mt-4"], ["type", "button", "jhiTranslate", "sessionChat.back", 1, "btn", "btn-secondary", "m-2", 3, "click"], ["type", "button", "jhiTranslate", "sessionChat.button.extendSession", 1, "btn", "btn-primary", "m-2", 3, "click"]], template: function SessionIsAboutToEndComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, SessionIsAboutToEndComponent_div_0_Template, 8, 3, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.secondsLeft);
    } }, directives: [i3.NgIf, i4.FaIconComponent, i5.JhiTranslateDirective], styles: [""] });
